import { TPrimitive } from '@/interfaces/common.interfaces';

function instanceOfPrimitive(object: any): object is TPrimitive {
  return (
    typeof object === 'string' ||
    typeof object === 'number' ||
    typeof object === 'boolean'
  );
}

export default instanceOfPrimitive;
